import { CommonModule } from '@angular/common';
import { Component, inject, input, Input, OnInit, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { DropDownKeywords, DropdownOption } from 'src/app/models/shared/dropdown-option';
import { DropdownService } from 'src/app/services/dropdown.service';
import { DropdownComponent } from "../../components/shared/dropdown/dropdown.component";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styles: [],
  standalone: true,
  imports: [CommonModule, DropdownComponent, FormsModule]
})
export class SearchComponent implements OnInit {
  withOutputData = input<boolean>(false);

  search = output<{
    provinceId: number,
    departmentId: number,
    positionId: number,
    professionalProfileId?: number
  }>({});

  @Input()
  typeSearch: string = 'Employee';

  private readonly dropdownService = inject(DropdownService);
  private readonly router = inject(Router);

  provinces: DropdownOption[] = [];
  deparments: DropdownOption[] = [];
  positions: DropdownOption[] = [];
  professionalProfiles: DropdownOption[] = [];

  filter: {
    provinceId: number,
    departmentId: number,
    positionId: number,
    professionalProfileId?: number
  } = {
    provinceId: 0,
    departmentId: 0,
    positionId: 0,
    professionalProfileId: 0
  };


  constructor() { }

  ngOnInit(): void {
    this.getOptions();
  }

  getOptions() {
    this.dropdownService.GetOptions(DropDownKeywords.Provinces).subscribe({
      next: res => {
        this.provinces = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.Departments).subscribe({
      next: res => {
        this.deparments = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.Positions).subscribe({
      next: res => {
        this.positions = res;
      }
    });
    this.dropdownService.GetOptions(DropDownKeywords.ProfessionalProfiles).subscribe({
      next: res => {
        this.professionalProfiles = res;
      }
    });
  }

  submit() {
    this.search.emit(this.filter);
  }

  redirectToSearch() {
    // Only include parameters that have values (not 0)
    const queryParams: any = {};
    
    if (this.filter.provinceId > 0) {
      queryParams.stateId = this.filter.provinceId;
    }
    
    if (this.filter.departmentId > 0) {
      queryParams.departmentId = this.filter.departmentId;
    }
    
    if (this.filter.positionId > 0) {
      queryParams.positionId = this.filter.positionId;
    }
    
    if (this.typeSearch === 'Freelancer') {
      queryParams.professionalProfileId = this.filter.professionalProfileId;
      
      // Navigate to the freelancer page with the parameters
      this.router.navigate(['/home/freelancer'], { queryParams });
    } else {
      // Navigate to the search page with the parameters
      this.router.navigate(['/home/search'], { queryParams });
    }
  }

}